const ContactTile = () => {
  return (
    <div to="/custom-template" className="group relative block overflow-hidden">
      <div className="flex h-64 w-full items-center justify-center">
        <div className="p-4 text-center">
          <h2 className="text-xl font-bold text-black">
            Din't find your template here?
          </h2>
          <p className="mt-2 text-sm text-gray-600">
            Don't worry!{' '}
            <span className="font-bold">We will create one for you.</span>
          </p>
          <p className="mt-2 text-sm text-gray-600">
            Contact:{' '}
            <a href="mailto:team@tailwine.in" className="underline">
              team@tailwine.in
            </a>
          </p>
        </div>
      </div>
    </div>
  );
};

export default ContactTile;
